// extracted by mini-css-extract-plugin
export var buttonsBlock = "FensterTurenWidget-module--buttonsBlock--d63f2";
export var container = "FensterTurenWidget-module--container--21798";
export var description = "FensterTurenWidget-module--description--7889e";
export var fullWidth = "FensterTurenWidget-module--fullWidth--f8de3";
export var personalInformationContainer = "FensterTurenWidget-module--personalInformationContainer--ef007";
export var question = "FensterTurenWidget-module--question--1ace3";